import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LyCheckbox } from './ly-checkbox/ly-checkbox.component';
import { LyCheckboxService } from './ly-checkbox.service';
export { LyCheckboxService } from './ly-checkbox.service';
export { LY_CHECKBOX_CONTROL_VALUE_ACCESSOR, CheckboxState, LyCheckbox } from './ly-checkbox/ly-checkbox.component';
var LyCheckboxModule = (function () {
    function LyCheckboxModule() {
    }
    /**
     * @return {?}
     */
    LyCheckboxModule.forRoot = function () {
        return {
            ngModule: LyCheckboxModule,
        };
    };
    return LyCheckboxModule;
}());
export { LyCheckboxModule };
LyCheckboxModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule
                ],
                exports: [LyCheckbox],
                declarations: [LyCheckbox],
                providers: [LyCheckboxService]
            },] },
];
/**
 * @nocollapse
 */
LyCheckboxModule.ctorParameters = function () { return []; };
function LyCheckboxModule_tsickle_Closure_declarations() {
    /** @type {?} */
    LyCheckboxModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyCheckboxModule.ctorParameters;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/checkbox/ly-checkbox.module.js
// module id = 1368
// module chunks = 31